import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: Props) {
  return (
    <header className="sr-page-header">
      <div className="sr-page-header__title">
        <h1>{title}</h1>
        {subtitle && <span className="sr-page-header__subtitle">{subtitle}</span>}
      </div>
      {actions && <div className="sr-page-header__actions">{actions}</div>}
    </header>
  );
}
